export default [
  {
    path: '/main/vehicles',
    meta: {
      tag: 'search_vehicle',
      name: 'Consultar veículo',
      breadcrumb: 'Consultar veículo',
      menu: 'settings'
    },
    component: () => import(/* webpackChunkName: "search-vehicle" */ '@/views/main/settings/consults/vehicles/Search.vue')
  }
]